import { CrudeTab } from '@3m5/crude-frontend/dist/shared/types/configurationTypes'
const crudeTabConfig = (): CrudeTab[] => {
  return [
    {
      entity: 'License',
      columns: [
        {
          name: 'name',
          hideInTableView: false,
          pinned: true,
          columnWidth: 200,
        },
        {
          name: 'licenseKey',
          hideInTableView: false,
          columnWidth: 200,
        },
        {
          name: 'notBefore',
          hideInTableView: false,
        },
        {
          name: 'expires',
          hideInTableView: false,
        },
        {
          name: 'maxMachines',
          hideInTableView: true,
        },
      ],
    },
    {
      entity: 'Machine',
      columns: [
        {
          name: 'name',
        },
        {
          name: 'machineKey',
        },
        {
          name: 'createdAt',
        },
      ],
    },
    {
      entity: 'App',
    },
    {
      entity: 'User',
    },
    {
      entity: 'ErrorLogs',
      columns: [
        {
          name: 'error',
          columnWidth: 300,
          pinned: true,
        },
        {
          name: 'licenseKey',
        },
        {
          name: 'machineName',
        },
        {
          name: 'machineKey',
        },
        {
          name: 'statusCode',
        },
        {
          name: 'createdAt',
          pinned: true,
          sort: 'desc',
        },
      ],
    },
    {
      entity: 'LicenseHasApp',
      hideEntity: true,
    },
    {
      entity: 'LicenseHasMachine',
      hideEntity: true,
    },
  ]
}
export default crudeTabConfig
